/**
 * Newness window for eval tasks — the single definition of "recently
 * added". A task shows a NEW chip (and counts toward the group card's
 * "added this week" line) for this many days after it joins the group.
 * Drafts are excluded everywhere: pending isn't added yet, and the DRAFT
 * chip already marks them.
 */

export const NEW_TASK_WINDOW_DAYS = 7

export function isNewTask(createdAt: string): boolean {
  const ageMs = Date.now() - new Date(createdAt).getTime()
  return ageMs < NEW_TASK_WINDOW_DAYS * 24 * 60 * 60 * 1000
}
